<template>
  <div class="step-wrapper">
    <div class="step-wrapper-subject"><strong>step 2 | select font</strong></div>

    <div class="step-wrapper-description mt-4 mb-4">
      <strong>Note:</strong> For small stencils use Arial and Script which can be used down to ½ inch.
      The other fonts can go to a small as ¾ inch
    </div>

    <b-list-group class="mt-4">
      <button v-for="font in fonts" v-bind:class="font.css_class" v-bind:disabled="font.disabled"
        v-bind:data-font="font.id" v-on:click="selectFont">
        {{font.name}}
      </button>
    </b-list-group>
    <b-button variant="default" class="mt-4 go-next" v-on:click="goNext">next</b-button>
  </div>
</template>

<script>
import { STENCILCONST } from '../modules/constant.js.erb'

export default {
  computed: {
    currentFont() {
      return this.$store.state.product.textFont;
    },
    currentFontSize() {
      return this.$store.state.product.textHeight;
    },
    availableFonts() {
      return this.$store.state.product.fonts;
    },
    fontName() {
      let info = {};
      STENCILCONST.fontInfo.forEach( font => info[font.id] = font.name );
      return info;
    },
    fonts() {
      return this.availableFonts.map(font => {
        let css_class = `list-group-item list-group-item-action font-${ font.id }`;

        if(this.currentFont == font.id) { css_class = `${css_class} active`; }

        let greater_than_restriction = 0;

        if (font.restrictions && font.restrictions.gt) {
          greater_than_restriction = font.restrictions.gt;
        }

        const disabled = this.currentFontSize <= greater_than_restriction;

        return {
          css_class: css_class, id: font.id, name: this.fontName[font.id],
          disabled: disabled
        };
      }).sort((a, b) => a.name > b.name);
    }
  },
  methods: {
    selectFont(evt) {
      const obj = evt.target;
      const font_id = obj.getAttribute('data-font');
      this.$store.dispatch('product/SET_TEXT_FONT', font_id);
    },
    goNext(evt) {
      this.$store.dispatch('product/SET_OLDTAB', 1);
      this.$store.dispatch('product/SET_ACTIVETAB', 1);
      this.$store.dispatch('product/SET_ACTIVETAB', 2);
    }
  }
}
</script>
